import React from "react";
import { useState } from "react";
import axios from "axios";
import "./loginregister.css";
import Image1 from "../../assets/images/login_page_img_two.png";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { apiurl } from "../../Constants";
function Deleteaccount() {
  const [inputFields, setInputfields] = useState({
    name: "",
    emailorphone: "",
    message: "",
  });
  const navigation = useNavigate();

  const [errors, setErrors] = useState({});

  const validaterrors = (inputvalues) => {
    let errors = {};
    if (inputvalues.name == "") {
      errors.name = "Name is required";
    }

    if (inputvalues.emailorphone == "") {
      errors.emailorphone = "Mobile Number or Email ID is required";
    }

    if (inputvalues.message == "") {
      errors.message = "Reason is required";
    }

    return errors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const validationerrors = validaterrors(inputFields);
    setErrors(validationerrors);

    if (Object.keys(validationerrors).length == 0) {
      const contactdata = async () => {
        try {
          const response = await axios.post(
            apiurl + "delecte_account_request",
            {
              name: inputFields.name,
              emailorphone: inputFields.emailorphone,
              message: inputFields.message,
            }
          );

          const data = response.data;
          if (response.status === 200 && data.success) {
            toast.success(response.data.message || "Submitted Succesfully");
          } else {
            toast.error("✖", { autoClose: 2000, className: "custom-toast" });
          }
        } catch (error) {
          console.error(error);
          toast.error(
            error.response?.data?.message || "An unexpected error occurred.",
            { autoClose: 2000 }
          );
        }
      };
      contactdata();
    }
  };

  const handlechange = (e) => {
    setInputfields({ ...inputFields, [e.target.name]: e.target.value });
  };

  return (
    <section className="loginregister_section pt-40 pb-40">
      <div className="container">
        <div className="row">
          <div className="login-page-padding col-lg-6 col-md-6 col-sm-12"></div>
          <div className="col-lg-6 col-md-6 col-sm-12 right_col">
            <div className="form_inner_box">
              <p className="text-center" style={{ fontSize: "12px" }}>
                Please Enter your Details Below To request Aammi Tharcharbu
                Santhai Accout Deletion in both Mobile app and Web application
              </p>
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label className="form-label mb-2">
                    Name
                    <sup className="mandatory_symbol">*</sup>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="name"
                    placeholder="Your Name"
                    value={inputFields.name}
                    onChange={handlechange}
                  />

                  {errors.name ? (
                    <p style={{ fontSize: "12px", color: "red" }}>
                      {errors.name}
                    </p>
                  ) : null}
                </div>
                <div className="mb-3">
                  <label className="form-label mb-2">
                  Registered Email Id or Mobile Number
                    <sup className="mandatory_symbol">*</sup>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="emailorphone"
                    placeholder="Registered Email Id or Mobile Number"
                    value={inputFields.emailorphone}
                    onChange={handlechange}
                  />

                  {errors.emailorphone ? (
                    <p style={{ fontSize: "12px", color: "red" }}>
                      {errors.emailorphone}
                    </p>
                  ) : null}
                </div>

                <div className="mb-3">
                  <label className="form-label mb-2">
                    Reason For Deleting Account <sup className="mandatory_symbol">*</sup>
                  </label>

                  <textarea
                    className="form-control"
                    name="message"
                   
                    rows="5"
                    onChange={handlechange}
                  >
                    {inputFields.message}
                  </textarea>

                  {errors.message ? (
                    <p style={{ fontSize: "12px", color: "red" }}>
                      {errors.message}
                    </p>
                  ) : null}
                </div>

                <div className="mb-3 text-center">
                  <button className="btn_1_1 " type="submit">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Deleteaccount;
